import axios from 'axios';

const judicialFeesPrefix = process.env.VUE_APP_MODULE_JudicialFees;
const CancelToken = axios.CancelToken;
const cancelRequests = {};

export default {
  getBillStatuses: () => axios.get(`${judicialFeesPrefix}/portal-bill-statuses`),
  getProviders: () => axios.get(`${judicialFeesPrefix}/providers`),
  getObjectionReasons: providerId => axios.get(`${judicialFeesPrefix}/objection-reasons/${providerId}`),
  getBillTimeline: objectKey => axios.get(`${judicialFeesPrefix}/bills/${objectKey}/timeline`),
  getBillDetails: objectKey => axios.get(`${judicialFeesPrefix}/bills/${objectKey}`),
  getBillItemDetails: objectKey => axios.get(`${judicialFeesPrefix}/bills/${objectKey}/item-details`),
  getBillAttributes: objectKey => axios.get(`${judicialFeesPrefix}/bills/${objectKey}/attributes`),
  getBillInvoiceReport: objectKey => axios.get(`${judicialFeesPrefix}/bills/${objectKey}/bill-Invoice-doc`),
  submitObjectionRequest: payload => axios.post(`${judicialFeesPrefix}/requests`, payload),
  getObjectionRequest: objectKey => axios.get(`${judicialFeesPrefix}/requests/${objectKey}`),
  getDeceasedBills: (payload) => {
    cancelRequests.getDeceasedBills && cancelRequests.getDeceasedBills();
    return axios.get(`${judicialFeesPrefix}/deceased-bills`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        // an executor function receives a cancel function as a parameter
        cancelRequests.getDeceasedBills = cancelFunction;
      }),
      params: payload,
    });
  },
  getMyBills: (payload) => {
    cancelRequests.getMyBills && cancelRequests.getMyBills();
    return axios.get(`${judicialFeesPrefix}/my-bills`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        // an executor function receives a cancel function as a parameter
        cancelRequests.getMyBills = cancelFunction;
      }),
      params: payload,
    });
  },
  getMyBillsStatistics: (payload) => {
    cancelRequests.getMyBillsStatistics && cancelRequests.getMyBillsStatistics();
    return axios.get(`${judicialFeesPrefix}/my-bills-statistics`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        // an executor function receives a cancel function as a parameter
        cancelRequests.getMyBillsStatistics = cancelFunction;
      }),
      params: payload,
    });
  },
  getBillUpdateDetails: objectKey => axios.get(`${judicialFeesPrefix}/bills/${objectKey}/update-details`),
};
